import { AfterViewInit, Directive, ElementRef, OnDestroy } from '@angular/core';

/**
 * Changes the z-index of the host element so that it will be displayed
 * on top of the main app header once it reaches the top of the page.
 * User Intersection Observables to reduce page load.
 */
@Directive({
  selector: '[appStickyPageHeader]',
})
export class StickyPageHeaderDirective implements AfterViewInit, OnDestroy {
  observer: IntersectionObserver;

  private readonly intersectionThreshold: number = 0.99;

  constructor(private hostElement: ElementRef) {}

  ngOnDestroy(): void {
    this.observer?.disconnect();
  }

  ngAfterViewInit(): void {
    const navbar = document.getElementById('app-header');
    const body = document.body;

    this.observer = new IntersectionObserver(
      ([e]) => {
        navbar.classList.toggle(
          'z-index-1',
          e.intersectionRatio < this.intersectionThreshold
        );
        body.classList.toggle(
          'sticky-header-active',
          e.intersectionRatio < this.intersectionThreshold
        );
      },
      {
        rootMargin: '-1px 0px 0px 0px',
        threshold: [this.intersectionThreshold],
      }
    );

    this.observer.observe(this.hostElement.nativeElement);
  }
}
